// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"905":"8f7b34cc","5016":"23c8d746","7748":"27d4fcbe"}[chunkId] + ".chunk.css";
};